<template>
  <div class="account-set">
    <!-- <navBan :goBack="closeApp" title="账户安全"></navBan> -->

<!--    用户信息-->
    <div class="user-info">
      <div class="avatar-box" :style="userInfo.avatarStyle">
      </div>
      <div class="user-data">
        <p class="name">{{userInfo.nickName}}</p>
        <p class="phone">{{userInfo.phonenumber}}</p>
      </div>
      <div @click="$router.push({ name: 'profile' });" class="btn-edit">编辑资料</div>
    </div>

<!--    登录方式-->
    <div class="panel">
      <p @click="createEruda" class="title">登录方式</p>
      <ul class="cell-box">
        <!-- @click="changeState('rebindPhone')" -->
        <li class="cell-item" @click="$router.push({ name: 'safeVerify',query:{'State':'rebindPhone'} })">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/Phone2.svg" alt="" style="width:16px;">
            <span class="title-text">绑定手机</span>
          </div>
          <div class="cell-value" >
            <span class="value-text">{{ bindData.phonenumber ? '已绑定' : '未绑定' }}</span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
        <li class="cell-item" @click="changeState('bindEmail')" v-if="PlatFormType != '1' && PlatFormType != '2'">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/Mail.svg" alt="">
            <span class="title-text">绑定邮箱</span>
          </div>
          <div  class="cell-value">
            <span class="value-text">{{ bindData.isBindEmail === 1 ?  '已绑定' : '未绑定'}}</span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>

        <li class="cell-item" @click="$router.push({ name: 'thirdPart' })">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/bind.svg" alt="">
            <span class="title-text">第三方账号</span>
          </div>
          <div class="cell-value">
            <span class="value-text">{{bindData.bindOtherCount || 0}}</span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
        <!-- @click="changeState('modifyPwd');"  -->
        <li class="cell-item" @click="$router.push({ name: 'safeVerify',query:{'State':'modifyPwd'} })">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/password.svg" alt="">
            <span class="title-text">修改密码</span>
          </div>
          <div  class="cell-value">
            <span class="value-text"></span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
      </ul>
    </div>

    <!-- 账号安全-->
    <div class="panel">
      <p class="title">账号安全</p>
      <ul class="cell-box">
        <li class="cell-item" @click="$router.push({ name: 'application' });">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/Authority.svg" alt="">
            <span class="title-text">应用授权</span>
          </div>
          <div class="cell-value">
            <span class="value-text">{{bindData.bindAppCount}}</span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
        <li class="cell-item" @click="$router.push({ name: 'loginDev' });">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/Equipment.svg" alt="">
            <span class="title-text">登录设备</span>
          </div>
          <div class="cell-value" >
            <span class="value-text">{{bindData.bindDeviceCount}}</span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>

        <li class="cell-item" v-if="PlatFormType != '1' && PlatFormType != '2'">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/Security.svg" alt="">
            <span class="title-text">密保问题</span>
          </div>
          <div class="cell-value">
            <span class="value-text"></span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
      </ul>
    </div>

    <!-- 隐私与帮助-->
    <!-- appType: 1管家通 2管家通商家版 -->
    <div class="panel" v-if="PlatFormType != '1' && appType != 1 && appType != 2">
      <p class="title">隐私与帮助</p>
      <ul class="cell-box">
        <li class="cell-item" style="display:none">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/help.svg" alt="">
            <span class="title-text">帮助中心</span>
          </div>
          <div class="cell-value">
            <span class="value-text"></span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
        <li class="cell-item" @click="showRegister">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/Agreement.svg" alt="">
            <span class="title-text">用户协议</span>
          </div>
          <div class="cell-value">
            <span class="value-text"></span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>

        <li @click="showPrivacy" class="cell-item">
          <div class="cell-title">
            <img class="icon" src="../../assets/images/mobile/Privacy.svg" alt="">
            <span class="title-text">隐私政策</span>
          </div>
          <div class="cell-value">
            <span class="value-text"></span>
            <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
          </div>
        </li>
      </ul>
    </div>

    <!-- 推出登录-->
    <div class="logout_box" v-show="showLogout" v-if="PlatFormType != '1' && PlatFormType != '2'">
      <ul class="cell-box" @click="logOutAccount">
        <li class="cell-item">
          <div class="cell-value">
            <img class="icon" src="../../assets/images/mobile/logout.svg" alt="">
            <span class="title-text">退出登录</span>
          </div>
        </li>
      </ul>
    </div>

    <!--统一安全验证的弹窗-->
    <safeVerify
      ref="safeCheck"
      pageType="h5"
      :checkVisible="checkVisible"
      @updateCheckVisible="updateCheckVisible"
      @handleOperate="handleOperate"
    />
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getUserInfo, bindData, getBingInfo } from '@/utils/setup/userInfo';
import { getAgreement, showPrivacy, showRegister } from '@/utils/setup/agreement';
import safeVerify from '@/components/safeVerify';
import eruda from 'eruda';
import Common, { receiveToken, appGoback, getAppToken } from '@/utils/common';
import navBan from '@/components/navBan';
import { useStore } from 'vuex';
import { Modal } from 'ant-design-vue';
import { MobileLogOut } from '@/utils/setup/logOut';

const store = useStore();
const userInfo = computed(() => store.state.userInfo);

const router = useRouter();

let appType = sessionStorage.getItem('appType');
const PlatFormType = ref(sessionStorage.getItem('PlatFormType'));

/** 关闭应用 */
function closeApp () {
  if (platFormType() === 'android') {
    window.android.onNavToApp();
  } else {
    window.webkit.messageHandlers.onNavToApp.postMessage(null); // 参数需为null 不能为空
  }
}

function platFormType () {
  let agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('android') >= 0) {
    return 'android';
  } else if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    return 'ios';
  }
}

const checkVisible = ref(false);
let operateType = ref('');
function updateCheckVisible (val) {
  checkVisible.value = val;
}
const safeCheck = ref('safeCheck');

function changeState (item) {
  if (item !== 'bindEmail') {
    operateType.value = item;
    safeCheck.value.operateState(item);
  }
}

function handleOperate (item) {
  router.push({ name: item });
}

async function logOutAccount () {
  Modal.confirm({
    class: 'modal-box-confirm',
    title: '退出登录',
    content: '确定注销并退出系统吗？',
    centered: true,
    cancelText: '取消',
    okText: '确定',
    onOk: async function () {
      await MobileLogOut();
    }
  });
}

let isApp = ref(false);
onBeforeMount(() => {
  window.document.title = '账号与安全';
  let agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('android') >= 0 || agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0 || agent.indexOf('hmos') >= 0) {
    isApp.value = true;
    appInit();
  } else {
    getUserInfo();
    getBingInfo();
    getAgreement();
    const PlatForm = sessionStorage.getItem('PlatFormType');
    if (PlatForm != 2) {
      showLogout.value = true;
    }
  }
  if (sessionStorage.getItem('PlatFormType')) {
    getUserInfo();
    getBingInfo();
    getAgreement();
  }
  window.sendToken = receiveToken;
  window.appGoback = appGoback;

  if (process.env.NODE_ENV === 'development') {
    getUserInfo(); // todo 开发调试
    getBingInfo();
    getAgreement();
  }
});
let showLogout = ref(false);
async function appInit () {
  await getAppToken();
  // ios注入时差
  setTimeout(() => {
    PlatFormType.value = sessionStorage.getItem('PlatFormType');
    const PlatForm = sessionStorage.getItem('PlatFormType');
    if (PlatForm != 1) {
      getUserInfo();
      getBingInfo();
      getAgreement();
      if (PlatForm != 2) {
        showLogout.value = true;
      }
    } else {
      showLogout.value = false;
    }
  }, 500);
}

let showErudaIndex = ref(0);
function createEruda () {
  showErudaIndex.value++;
  if (showErudaIndex.value !== 4) {
    return;
  }
  let el = document.createElement('div');
  document.body.appendChild(el);
  eruda.init({
    container: el,
    tool: ['console', 'elements', 'Network', 'Resource', 'Info', 'Snippets', 'Sources'],
    useShadowDom: true
  });
}
</script>

<style lang="scss" scoped>
.account-set {
  padding:16px 16px;
  .user-info {
    padding: 16px;
    display: flex;
    align-items: center;
    .avatar-box {
      flex: none;
      height: 60px;
      width: 60px;
      overflow: hidden;
      border-radius: 50%;
    }
    .user-data {
      margin-left: 12px;
      width: 147px;
      .name {
        color: rgba(0, 19, 46, 1);
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        width:145px;
        word-break: break-all;
      }
      .phone {
        margin-top: 8px;
        color: rgba(134, 143, 156, 1);
        font-family: PingFang SC;
        font-size: 14px;
        line-height: 14px;
      }
    }
    .btn-edit {
      margin-left: 12px;
      width: 80px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 40px;
      border: 0.5px solid rgba(233, 237, 243, 1);
      background: rgba(255, 255, 255, 1);

      color: rgba(68, 129, 235, 1);
      font-family: PingFang SC;
      font-size: 12px;
    }
  }

  .panel {
    width: 100%;
    border-radius: 6px;
    box-shadow: 0px 16px 20px rgba(165, 175, 186, 0.06);
    background: rgba(255, 255, 255, 1);
    .title {
      margin-left: 16px;
      padding: 14px 0;
      color: rgba(134, 143, 156, 1);
      font-family: PingFang SC;
      font-size: 12px;
      border-bottom: 1px solid #E9EDF3;
    }
  }
  .panel+.panel {
    margin-top: 16px;
  }

  .logout_box{
    width: 100%;
    border-radius: 6px;
    box-shadow: 0px 16px 20px rgba(165, 175, 186, 0.06);
    background: rgba(255, 255, 255, 1);
    text-align: center;
    margin-top:16px;
  }
  .logout_box > .cell-box{
    margin-top:0;
    display: inline-block;
  }
}
</style>
